// extracted by mini-css-extract-plugin
export default {"calendar-row":"FewMonthMiniCalendar_calendar-row__0ijZL","calendarRow":"FewMonthMiniCalendar_calendar-row__0ijZL"};